import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

interface SmallLoadingDialogData {
  message?: string;
}

@Component({
  selector: 'app-small-loading-dialog',
  templateUrl: './small-loading-dialog.component.html',
  styleUrls: ['./small-loading-dialog.component.css'],
})
export class SmallLoadingDialogComponent {
  readonly message: string;

  constructor(@Inject(MAT_DIALOG_DATA) data: SmallLoadingDialogData | null) {
    this.message = String(data?.message || 'Working...').trim() || 'Working...';
  }
}
